export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  SetUser: "[Set User] Action",
  RefreshUser: "[Refresh User] Action",
  ImpersonateLogin: "[Impersonate Login] Action",
};

export const actions = {
  login: (access, refresh, user, remember) => ({
    type: actionTypes.Login,
    payload: { access, refresh, user, rememberMe: remember },
  }),
  refresh: (access) => ({
    type: actionTypes.RefreshUser,
    payload: { access },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  impersonateLogin: (access) => ({
    type: actionTypes.ImpersonateLogin,
    payload: { access },
  }),
};
